module.exports = __webpack_public_path__ + "assets/img/bell.f4ffd87b.svg";